import { CONFIGURATOR_IMAGE_ENDPOINT } from '@constants/endpoints';

// TODO: Add fallback for image failed image fetch
export const getImage = ({
  shortcode,
  width = 650,
  height = 364,
  camera = 'CAM_EXT_08',
  format = 'processed',
  scene = 'studio',
}) => {
  if (shortcode) {
    const imageOptions = {
      shortcode,
      width,
      height,
      format,
      camera,
    };

    if (scene === 'alpha') {
      imageOptions['background_colour'] = '00000000';
      imageOptions['env'] = 'lucid_studio';
    } else {
      imageOptions['env'] = scene;
    }

    const queryParams = new URLSearchParams(imageOptions);
    return `${CONFIGURATOR_IMAGE_ENDPOINT}/?${queryParams}`;
  } else {
    return '';
  }
};

export default getImage;
